export default __webpack_public_path__ + "static/media/icon-newsfeed-active.da7de6c8.svg";